<template>
  <div class="flex flex-col gap-5">
    <div class="text-start">
      <h4 class="text-md font-bold">Cart Update</h4>
    </div>
    <div class="flex flex-col gap-5">
      <p class="text-sm">You already have items in your cart. Would you like to add items from this order or replace the cart?</p>
      <div class="inline-flex gap-12">
        <div class="w-1/2">
          <UButton size="xl" label="Replace" variant="outline" block @click="replaceCartItem"/>
        </div>
        <div class="w-1/2">
          <UButton size="xl" label="Add"  block @click="addToExistingCart"/>

        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { gtag } = useGtag();
const auth = useAuth();
  const isAuthenticated = auth && auth.access_token;
  const userData = isAuthenticated ? {
    user_name: auth.user.first_name,
    user_phone: auth.user.phone,
    user_email: auth.user.email,
  } : {
    user_name: null,
    user_phone: null,
    user_email: null
  };
const cart = useCart();

const emit = defineEmits(['success', 'close', 'add']);
const props = defineProps({
  data: {
    type: Array,
    default: () => []
  },
  orderItems: {
    type: Array,
    default: () => []
  }
});

const replaceCartItem = () => {
    gtag('event', 'Reorder_multiallowed_replace', {
        action: 'click',
        cta_name: 'replace cart',
        ...userData,
    });
    cart.clear();
  emit('success');
};

const addToExistingCart = () => {
  gtag('event', 'Reorder_multiallowed_add', {
    action: 'click',
    cta_name: 'Added items to existing cart',
    ...userData,
  });

  emit('add');

//   props.data.forEach(product => {
//   const qty = product.qty || 1;

//   for (let i = 0; i < qty; i++) {
//     cart.addItem({
//       ...product,
//       parent_item_id: product.sku_id,
//       qty: 1
      
//     });
//   }
// });
//   navigateTo('/cart');
};
</script>